import {Pipe, PipeTransform} from '@angular/core';
import {HolidayDto} from '../../../Models/Rrhh/Holidays/holiday.interface';

@Pipe({
  name: 'holidays',
  standalone: false
})
export class HolidaysPipe implements PipeTransform {

  transform(items: HolidayDto[], filter: { past: boolean }): HolidayDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    return items.filter((item) => item['pasado'] === filter.past);

  }

}
